import React from 'react';
import { Container } from './styles';
import { LandingHeader } from 'pages/landing/Header';
import { LandingFooter } from 'pages/landing/Footer';
import { BodyLanding } from 'pages/landing/Body';
import { DocumentHead } from 'components/DocumentHead';
import { isCdkEnvironment } from 'utils/constants';

export const LandingPagePreview = () => {
  const title = isCdkEnvironment
    ? 'CDK Landing Preview'
    : 'Covideo Landing Page Preview';
  return (
    <>
      <DocumentHead title={title} />
      <Container className='new-lp-flow'>
        <LandingHeader />
        <BodyLanding />
        <LandingFooter />
      </Container>
    </>
  );
};
